<template>
  <el-container class="ProductionMultiForm">
    <el-main class="p-0 pb-default">
      <el-tabs>
        <el-tab-pane
          v-for="(item, index) in selection"
          v-bind:key="item.contract_detail_id"
          :label="item.customer_name + '-' + item.product_name"
          :name="index.toString()"
        >
          <ProductionForm
            :ref="'form'"
            :source="util.clone(item)"
            hideFooter
            @loaded="handleLoaded"
            @completed="handleCompleted"
          />
        </el-tab-pane>
      </el-tabs>
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        v-shortkey="['F4']"
        :disabled="loaded_count < selection.length"
        :loading="load_button"
        @shortkey.native="handleClickRegister"
        @click="handleClickRegister"
        >{{ $t("button.register") }}(F4)</el-button
      >
      <el-button class="close-button" @click="closeDialog"
        >{{ $t("button.close") }}(Esc)</el-button
      >
    </el-footer>
  </el-container>
</template>
<script>
import { form } from "@/common/mixins/form";
import ProductionForm from "./ProductionForm";

export default {
  name: "ProductionMultiForm",
  mixins: [form],
  components: { ProductionForm },
  data() {
    return {
      loaded_count: 0,
      completed_count: 0,
    };
  },
  props: {
    selection: {
      type: Array,
      required: true,
    },
    load_button: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    handleLoaded() {
      this.loaded_count++;
    },
    handleClickRegister() {
      if (this.loaded_count < this.selection.length) {
        return;
      }
      this.load_button = true;
      for (let i = 0; i < this.selection.length; i++) {
        let form = this.$refs.form[i];
        form.doRegister();
      }
    },
    handleCompleted() {
      this.completed_count++;
      if (this.completed_count < this.selection.length) {
        return;
      }
      this.$emit("completed", true);
    },
  },
};
</script>
